// extracted by mini-css-extract-plugin
export default {"editableTextField":"RenegerateCompetenceModal_editableTextField__EyVMn"};